import React, { useEffect, useState } from "react";
import client from "@/lib/api";

/**
 * Site-wide holiday-mode banner. Polls /holiday-mode and shows a high-contrast
 * notice when the studio is on holiday. Auto-hides once today > end_date + 2 days
 * (the server already enforces this — we mirror it client-side for safety).
 */
export default function HolidayBanner() {
  const [info, setInfo] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const load = () => {
      client.get("/holiday-mode")
        .then((r) => { if (!cancelled) setInfo(r.data); })
        .catch(() => {});
    };
    load();
    // Refresh every 10 min so an admin toggle propagates without a hard reload.
    const handle = setInterval(load, 600000);
    return () => { cancelled = true; clearInterval(handle); };
  }, []);

  if (!info?.active || !info.message || dismissed) return null;

  return (
    <div
      className="bg-[#1A2A4A] text-white px-6 md:px-12 py-3 flex items-start justify-between gap-4"
      data-testid="holiday-banner"
    >
      <div className="text-sm md:text-base leading-snug max-w-5xl">
        <span className="label-eyebrow text-[#FFD6CF] mr-2">Studio notice</span>
        <span className="text-white/90">{info.message}</span>
        {info.note && <div className="text-xs text-white/60 mt-1">{info.note}</div>}
      </div>
      <button
        onClick={() => setDismissed(true)}
        className="text-white/60 hover:text-white text-xs label-eyebrow shrink-0"
        data-testid="holiday-banner-dismiss"
        aria-label="Dismiss holiday notice"
      >
        Got it ✕
      </button>
    </div>
  );
}
